<script setup>
const AppDialog = defineAsyncComponent(() => import("~/components/AppDialog.vue"));
const AppToast = defineAsyncComponent(() => import("~/components/AppToast.vue"));
const ProfileTabs = defineAsyncComponent(() => import("~/components/Profile/ProfileTabs.vue"));


const { modalStatus } = useProfile()

if (localStorage.theme === 'dark') {
  document.documentElement.classList.add('dark')
} else {
  document.documentElement.classList.remove('dark')
}


const isSidebarOpen = ref(false);

const openSidebar = () => {
  isSidebarOpen.value = true;
  document.body.classList.add('max-md:!overflow-hidden');
  document.body.classList.add('max-md:!overflow-y-hidden');
}
const closeSidebar = () => {
  isSidebarOpen.value = false;
  document.body.classList.remove('max-md:!overflow-hidden');
  document.body.classList.remove('max-md:!overflow-y-hidden');
}
</script>

<template>
  <div>
    <NuxtLoadingIndicator :height="4" style="transform-origin: right center;" color="#1EB35B"/>
    <section class="relative flex lg:items-start lg:gap-x-8 lg:p-9 max-w-[1440px] mx-auto">
      <div :class="[isSidebarOpen ? ['visible', 'opacity-100'] : ['invisible', 'opacity-0']]" class="fixed inset-0 bg-black/20 md:hidden z-40 transition-all duration-300" @click="closeSidebar"></div>
      <AppSidebar :isOpen="isSidebarOpen" @close-nav="closeSidebar" @open-profile-modal="modalStatus = true"/>
      <section class="flex flex-col lg:gap-y-8 w-full overflow-hidden">
        <AppHeader @open-nav="openSidebar" @open-profile-modal="modalStatus = true"/>
        <div id="below-header"></div>
        <section class="bg-white p-5 sm:p-7 lg:rounded-lg h-full lg:dark:darker-gradient">
          <NuxtPage/>
        </section>
      </section>
      <AppToast/>
    </section>
    <AppDialog v-model:open="modalStatus" :center="false" class="w-[90%] xs:max-w-100 xs:w-full">
      <DialogTitle class="mb-8 sm:text-t4 font-bold">ویرایش حساب کاربری</DialogTitle>
      <ProfileTabs/>
    </AppDialog>
  </div>
</template>

<style>
#below-header:empty{
  display: none;
}

.page-enter-active,
.page-leave-active {
  transition: all 0.2s ease-in-out;
}

.page-enter-from {
  opacity: 0;
  transform: translateX(20px);
}

.page-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>